import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FiCalendar } from "react-icons/fi";

import "../styles/_datepicker.scss";
import { tr } from "date-fns/locale";

function CustomDatePicker({ date, setDate, setError }) {
  return (
    <div className="relative w-[180px]">
      <DatePicker
        selected={date}
        onChange={(date) => {
          setError(null);
          setDate(date);
        }}
        calendarClassName="custom-calendar"
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        className="w-full h-[52px] text-[13px] py-2 px-4 pr-10 rounded border border-[#e0e0e0] font-medium placeholder:text-[#848484] placeholder:text-[14px] focus:border focus:border-solid focus:border-[#00394D] focus-visible:outline-none"
        dateFormat="dd/MM/yyyy"
        placeholderText="DD/MM/YYYY"
      />
      <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
        <button>
          {" "}
          <FiCalendar size={20} />
        </button>
      </div>
    </div>
  );
}

export default CustomDatePicker;
